export default __webpack_public_path__ + "static/media/logo-new.fb30f838.png";